import { Tags } from 'lucide-react';
import { Breadcrumb } from '../../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../../components/settings/SettingsMenu';
import { ROUTING_SETTINGS_PATH } from '../routingRules';

/*
  What Routing configures — one row per surface, each leading to its own page. One row today, the
  catalog both registers file under, so the route and the sidebar entry carry its key. A row added
  owes its key to both in the same change, as `anyOf`.
*/
const ENTRIES: SettingsMenuEntry[] = [
  {
    key: 'document-types',
    label: 'Document Types',
    description: 'What a routed document is — Letter, Memorandum, Endorsement — for both Receiving and Dispatching.',
    icon: Tags,
    to: `${ROUTING_SETTINGS_PATH}/document-types`,
    permission: 'routing-document-types.read',
  },
];

/**
 * Routing → Settings: a **menu of what the group configures**, not the settings themselves. Each
 * row leads to a full page.
 */
export function RoutingSettingsPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col bg-slate-50">
      <Breadcrumb segments={['Document Management', 'Routing', 'Settings']} />

      <div className="modern-scrollbar min-h-0 flex-1 overflow-auto p-4">
        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          <p className="text-xs text-slate-500">
            The vocabulary Receiving and Dispatching draw on. The documents themselves are on their own pages.
          </p>

          <SettingsMenu entries={ENTRIES} />
        </div>
      </div>
    </div>
  );
}
